import type { CapabilityControlProps } from '../../core/types';
import { resolveFieldMode } from './resolveFieldMode';

export interface ShouldSkipCapabilityFetchOptions {
  /** L1 options.skipFetch 或调用方显式传入 */
  skipFetch?: boolean;
  /**
   * 逻辑 field key（与 accessPolicy / fieldModes 一致）。
   * 当全部为非 editable 时跳过列表类 API。
   */
  fieldKeys?: string[];
}

function isNonEditableField(fieldPath: string, control: CapabilityControlProps): boolean {
  const mode = resolveFieldMode(fieldPath, control);
  return mode === 'readonly' || mode === 'hidden' || control.blockMode === 'preview';
}

/**
 * 能力块列表类 API 请求门禁：preview、显式 skipFetch，或关联字段全部只读/隐藏时跳过。
 */
export function shouldSkipCapabilityFetch(control: CapabilityControlProps, options?: ShouldSkipCapabilityFetchOptions): boolean {
  if (options?.skipFetch === true) return true;
  if (control.blockMode === 'preview') return true;
  const keys = options?.fieldKeys;
  if (!keys?.length) return false;
  return keys.every((key) => isNonEditableField(key, control));
}
